import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'mca_auth_token';

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = sessionStorage.getItem(TOKEN_KEY);
        if (token) {
          const response = await axios.get(`${API_URL}/api/auth/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setUser(response.data);
        }
      } catch (error) {
        sessionStorage.removeItem(TOKEN_KEY);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    checkAuth();
  }, []);

  const login = async (username, password) => {
    const response = await axios.post(
      `${API_URL}/api/auth/login`,
      { username, password }
    );
    sessionStorage.setItem(TOKEN_KEY, response.data.token);
    setUser(response.data);
    return response.data;
  };

  const logout = async () => {
    try {
      const token = sessionStorage.getItem(TOKEN_KEY);
      await axios.post(`${API_URL}/api/auth/logout`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (error) {
      console.warn('Logout API call failed (non-critical):', error.message);
    }
    sessionStorage.removeItem(TOKEN_KEY);
    setUser(null);
  };

  const getToken = () => sessionStorage.getItem(TOKEN_KEY);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
